import { BrowserRouter, Routes, Route, Navigate } from "react-router";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "@/lib/auth";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import ChatPage from "@/pages/ChatPage";
import SearchPage from "@/pages/SearchPage";
import UnauthenticatedPage from "@/pages/UnauthenticatedPage";
import RouterWrapper from "@/lib/RouterWrapper";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/toaster";
import { getEmbedConfig } from "@/lib/embed/config";
import { getTeamsConfig } from "@/lib/teams/config";
import EmbedApp from "@/components/embed/EmbedApp";
import TeamsApp from "@/components/teams/TeamsApp";

function AuthenticatedApp() {
  return (
    <BrowserRouter>
      <RouterWrapper>
        <Routes>
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="*" element={<Navigate to="/chat" replace />} />
        </Routes>
      </RouterWrapper>
    </BrowserRouter>
  );
}

export default function App() {
  if (getTeamsConfig().teamsEnabled) return <TeamsApp />;
  if (getEmbedConfig().embedMode) return <EmbedApp />;

  return (
    <TooltipProvider>
      <MsalProvider instance={msalInstance}>
        <AuthenticatedTemplate>
          <AuthenticatedApp />
        </AuthenticatedTemplate>

        <UnauthenticatedTemplate>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<UnauthenticatedPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </UnauthenticatedTemplate>
      </MsalProvider>
      <Toaster />
    </TooltipProvider>
  );
}
